<template>
  <div class="">
    <div v-if="!this.initialLoading">
      <div class="container-bg-white mt-3 p-3">
        <div class="row">
          <div class="col-12 col-md-6">
            <h2 class="pl-0 mt-0">{{ $t("flexben.clients_guarantee.title") }}</h2>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col-12 mb-2 text-bold"
               v-show="upload_import.show"
               :class="{'text-danger':upload_import.failed, 'text-success':!upload_import.failed}"
          >{{ upload_import.message }}
          </div>
          <div class="col-12 col-md-6 col-xl-4">
            <input type="file" class="d-none" ref="upload_import" @change="handleFileUpload()">
            <button class="btn btn-themed"
                    @click="function (){$refs['upload_import'].click()}"
            >{{
              $t('flexben.clients_guarantee.buttons.import') }}
            </button>
          </div>

          <div class="col-12 col-md-6 col-xl-4 text-xl-right mt-2 mt-xl-0">
            <button class="btn btn-themed text-white"
                    @click="downloadExport()">
              {{ $t('flexben.clients_guarantee.buttons.export') }}
            </button>
          </div>
        </div>


        <div class="row">
          <div class="col-12">
            <div class="table-responsive hover-table">
              <table class="table table-striped">
                <thead>
                <tr>
                  <td>{{ $t("flexben.clients_guarantee.table.client_id") }}</td>
                  <td>{{ $t("flexben.clients_guarantee.table.client_name") }}</td>
                  <td>{{ $t("flexben.clients_guarantee.table.client_identifier") }}</td>
                  <td>{{ $t("flexben.clients_guarantee.table.available_amount") }}</td>
                  <td>{{ $t("flexben.clients_guarantee.table.mb_consumed_amount") }}</td>
                  <td>{{ $t("flexben.clients_guarantee.table.invoice_amount") }}</td>
                  <td>{{ $t("flexben.clients_guarantee.table.diff") }}</td>
                  <td>{{ $t("flexben.clients_guarantee.table.notification_percent") }}</td>
                  <td>{{ $t("flexben.clients_guarantee.table.updated_at") }}</td>
                  <td></td>
                </tr>
                </thead>
                <tbody>
                <template v-if="list.data.length>0">
                  <tr v-for="(item) of list.data" :key="item.id"
                      class="trhover parent">
                    <td>{{ item.company.id }}</td>
                    <td>{{ item.company.name }}</td>
                    <td>{{ item.company.identifier }}</td>
                    <td>{{ item.available_amount }}</td>
                    <td>{{ item.mb_consumed_amount }}</td>
                    <td>{{ item.invoice_not_paid_amount }}</td>
                    <td>{{ parseFloat(item.available_amount - item.mb_consumed_amount - item.invoice_not_paid_amount)}}</td>
                    <td>{{ item.notification_percent }}</td>
                    <td class="text-bold">{{item.updated_at ? moment(item.updated_at, 'DD.MM.YYYY') : 'N/A' }}</td>

                  </tr>
                </template>
                <template v-else>
                  <tr class="trhover gri-cell">
                    <td colspan="100" class="text-center">{{ $t("flexben.general.no_results_found") }}
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-12 p-0">
            <listPagination
              :activePage="list.current_page"
              :currentPage="list.current_page"
              :totalItems="list.total"
              :startItem="list.from"
              :endItem="list.to"
              :itemsPerPage="list.perPage"
              @pageChanged="pageChanged"
              @changePerPage="changePerPage"></listPagination>
          </div>
        </div>
      </div>

    </div>
    <content-loader :loader-visible="loading" :loader-error="loaderError"></content-loader>
  </div>
</template>

<script>
import httpFlexbenService from "@/http/http-flexben.js";
import i18n from "@/plugins/language/i18n";
import utils from "@/plugins/utils";

export default {
  name: "ClientsGuaranteeIndex",
  data() {
    return {
      httpService: httpFlexbenService.clientsGuarantee,
      httpExportServices: httpFlexbenService.exports,
      initialLoading: true,
      loading: true,
      loaderError: false,
      popUpModal: false,
      isAdmin: true,
      filters: {
        page: 1,
        perPage: 20
      },

      list: {
        data: [],
        current_page: 1,
        to: 1,
        perPage: 1,
        lastPage: 1,
        total: 1
      },
      upload_import: {
        show: false,
        failed: false,
        message: null
      },

    }
  },
  watch: {
    filters: {
      handler: function (val) {
        this._loadList();
      },
      deep: true
    },
    showCard: {
      handler: function (val) {
        if (!val) {
          this._setImportErrors(false);
        }
      }
    }
  },
  created() {
    let userRole = this.flxUserLevel().userLevel;
    const employment = this.$store.getters.flx_activeEmployment;
    if (userRole === 'client' && employment != null) {
      this.filters.company = employment.company_id;
      this.isAdmin = false;
    } else if (userRole === 'admin') {
      if (typeof localStorage.getItem('flexbenCompanyId') !== "undefined" && localStorage.getItem('flexbenCompanyId') !== null) {
        this.filters.company = this.filters.company = localStorage.getItem('flexbenCompanyId');
        localStorage.removeItem('flexbenCompanyId');
      }
      this.isAdmin = true;
    } else {
      window.location.href = '/';
      return;
    }

    this._loadList();
  },
  methods: {
    _loadList() {
      this.loading = true;

      this.httpService.list(this.filters)
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          this.list = {
            data: data.data,
            current_page: data.current_page,
            to: data.to,
            perPage: data.perPage,
            lastPage: data.lastPage,
            total: data.total
          };

          this.initialLoading = false;
          this.loading = false;
        })
        .catch((error) => {
          this.list = {
            data: [],
            current_page: 1,
            to: 1,
            perPage: 1,
            lastPage: 1,
            total: 1
          };
          if (error.response.status >= 500 && error.response.status < 600) {
            this.loaderError = true;
          }
        });
    },
    handleFileUpload() {
      console.log('before form data')

      let payload = new FormData();
      console.log('after form data')
      payload.append('file', this.$refs['upload_import'].files[0]);
      console.log('after append')
      this._setImportErrors(false);
      this._toggleLoading(true);
      this.httpService.uploadImport(payload)
        .then(function (response) {

          let loading = false, errorLoader = false;
          if (response.data.status === 200) {
            this.$refs['upload_import'].value= null;
            this._setImportErrors(true);
            this._loadList();
          } else {
            this.$refs['upload_import'].value= null;
            this._setImportErrors(true, true, response.data.message);

            if (response.data.data.message === null) {
              loading = true;
              errorLoader = true;
            }

          }
          payload = null;
          this._toggleLoading(loading, errorLoader);
        }.bind(this))
        .catch(function (error) {
          this._toggleLoading(true, true);
        }.bind(this));
    },
    downloadExport() {
      this._toggleLoading(true);
      let instance = this;
      let filters = {...this.filters};
      filters.lang = i18n.locale;
      this.httpExportServices.clients_guarantee(filters)
        .then(function (response) {
          utils.generateDownloadFromReponse(response);
        }).finally(() => {
        instance._toggleLoading(false);
      });
    },
    changePerPage(perPage) {
      this.filters.page = 1;
      this.filters.perPage = perPage;
      this._loadList();
    },
    pageChanged(page) {
      this.filters.page = page;
      this._loadList();
    },

    closeModal() {
      if (this.isAdmin) {
        this.selectedCompany.id = null;
      }
      this.openModal = false;
    },

    _toggleLoading(loading, loaderError = false) {
      this.loading = loading;
      this.loaderError = loaderError;
    },
    _setImportErrors(show, failed = false, errorMessage = null) {
      this.upload_import.show = show;
      if (failed) {
        this.upload_import.failed = failed;
        this.upload_import.message = errorMessage !== null ? errorMessage : null;
      } else {
        this.upload_import.message = this.$t('flexben.beneficiaries.mass_actions.messages.import_success');
      }
    }
  },
};
</script>
